export default "__VITE_ASSET__C70Rtq0o__"